import { Injectable, Inject } from '@angular/core';
import { AuthHttp } from 'angular2-jwt';
import { APIBase } from './api.base';
import { Router } from '@angular/router';
import { SessionStorageService } from '../services/session-storage.service';
import { Http } from '@angular/http';

@Injectable()
export class CustomersAPI extends APIBase {

	constructor(
		@Inject(AuthHttp) authHttp: AuthHttp,
		@Inject(Router) router: Router,
		@Inject(SessionStorageService) session: SessionStorageService,
		public http: Http) {

		super(authHttp, router, session);

		// Entidade principal
		this.__entity = 'customers';
	}

	/**
	 * getCidade por Id
	 *
	 *
	 * @access public
	 * @author Nicolas Aoki
	 * @since  12/2019
	 * @param  string
	 * @return object Promise
	 */
	public getCityById(cidadeId) {
		return this._call(this.__entity + '/get_city_by_id/', {id: cidadeId}, 'get');
	}
		/**
	 * getCities
	 *
	 * Realiza a busca da lista associativa
	 *
	 * @access public
	 * @author Elian Medeiros
	 * @since  05/2018
	 * @param  string
	 * @return object Promise
	 */
	public getCities(uf) {
		return this._call(this.__entity + '/get_cities/', {uf: uf}, 'get');
	}

	/**
	 * getUf
	 *
	 * @access public
	 * @author Elian Medeiros
	 * @since  05/2018
	 * @param  string
	 * @return object Promise
	 */
	public getUf() {
		return this._call(this.__entity + '/get_ufs/', {}, 'get');
	}


	/**
	 * save
	 *
	 * Salva os dados
	 *
	 * @access public
	 * @author Elian Medeiros
	 * @param  object
	 * @return object Promise
	 */
	public customSetForm(userId, processoId) {
		return this._call(this.__entity+'/set_form/', {UsuarioId: userId,ProcessoId: processoId}, 'get');	
	}


	/**
	 * save
	 *
	 * Salva os dados
	 *
	 * @access public
	 * @author Elian Medeiros
	 * @param  object
	 * @return object Promise
	 */
	public save(data) {
		// substitui objeto por string
		let objSend = Object.assign({}, data);
		objSend.FichaCadastral = JSON.stringify(objSend.FichaCadastral);
		return this._call(this.__entity, objSend, (data.id) ? 'put' : 'post');
	}


	/**
	 * save
	 *
	 * Salva os dados
	 *
	 * @access public
	 * @author Elian Medeiros
	 * @param  object
	 * @return object Promise
	 */
	public async viaCep(cep) {
		return this.http.get('https://viacep.com.br/ws/' + cep + '/json/').toPromise();
	}

	/**
	 * getAddressByCep
	 *
	 * @access public
	 * @author Henrique de Castro
	 * @since  12/2018
	 * @param  string
	 * @return object Promise
	 */
	public getAddressByCep(cep) {
		return this._call(this.__entity + '/get_address_by_cep/', {'Cep' : cep});
	}
}


// WEBPACK FOOTER //
// ./src/api/customers.api.ts